

















import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import { TimeEntryDay, TimeEntryDayApprovalEditModel, TimeEntryDayApprovalEnum } from '@/services/api/nswag/stapiclient_generated';
  import { TimeEntryStore } from '@/store/time-entry-store';
  import { DateTime } from 'luxon';
  import { UserStore } from '@/store/user-module';
  import {stTimeEntryDayApprovalApi} from '@/services/st-api';

  @Component({
    components: {},
  })
  export default class TimeEntriesApproval extends Vue {
    @Prop() currentDate: DateTime;

    get currentDayCanBeSubmitted(): boolean {
      const day = this.timeEntryDays.find((_) => _.entryDay.substring(0, 10) == this.currentDate.toFormat('yyyy-MM-dd'));
      if (!day) {
        return true;
      }

      return day.appUserDay.dayCanBeSubmitted;
    }

    get currentWeekCanBeSubmitted(): boolean {
      if (this.timeEntryDays.map((_) => _.appUserDay.dayCanBeSubmitted).filter((_) => _ === true).length) {
        return true;
      }
      return false;
    }

    get dayLockedComment(): string {
      const day = this.timeEntryDays.find((_) => _.entryDay.substring(0, 10) == this.currentDate.toFormat('yyyy-MM-dd'));
      if (!day) {
        return '';
      }

      return day.appUserDay.dayLockedApprovalComment;
    }

    get timeEntryDays(): TimeEntryDay[] {
      return TimeEntryStore.TimeEntryDays;
    }

    @Emit('approvalChanged')
    async submitDay() {
      let model = TimeEntryDayApprovalEditModel.fromJS({});
      model.appUserId = UserStore.currentUser.id;
      model.approvalEnum = TimeEntryDayApprovalEnum.IsSubmitted;
      model.date = this.currentDate.toFormat("yyyy-MM-dd");
      model.approvalMode = 'day';

      await stTimeEntryDayApprovalApi.setTimeEntryDayApproval(model);
    }

    @Emit('approvalChanged')
    async submitWeek() {
      let model = TimeEntryDayApprovalEditModel.fromJS({});
      model.appUserId = UserStore.currentUser.id;
      model.approvalEnum = TimeEntryDayApprovalEnum.IsSubmitted;
      model.date = this.currentDate.toFormat("yyyy-MM-dd");
      model.approvalMode = 'week';

      await stTimeEntryDayApprovalApi.setTimeEntryDayApproval(model);
    }
  }
